import CustomTableCreate from './CustomTableCreate';

class TagCreate extends CustomTableCreate {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'immutable') {
            return true
        }
        return false
    }

}

export default TagCreate;
